import { useEffect } from 'react';

export default function SEO({ title, description, path = '', image = '/logo.png', keywords = '' }) {
  const siteName = 'GetBenefitSavings';
  const baseUrl = 'https://getbenefitsavings.com';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Maximize Your Credit Card Benefits & Employee Perks`;
  const fullUrl = `${baseUrl}${path}`;
  const defaultDesc = 'Expert guidance to unlock thousands in credit card benefits and employee perks. Over 30 years of benefits expertise helping you save smarter.';
  const desc = description || defaultDesc;
  const fullImage = image.startsWith('http') ? image : `${baseUrl}${image}`;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name, content, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', desc);
    setMeta('keywords', keywords);
    setMeta('robots', 'index, follow');

    // Open Graph
    setMeta('og:type', 'website', true);
    setMeta('og:url', fullUrl, true);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', desc, true);
    setMeta('og:image', fullImage, true);
    setMeta('og:site_name', siteName, true);

    // Twitter
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:url', fullUrl);
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', desc);
    setMeta('twitter:image', fullImage);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);
  }, [fullTitle, desc, fullUrl, fullImage, keywords]);

  return null;
}
